import { auth } from '../firebase';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3800';

export const searchFranchisees = async (searchString) => {
  if (!searchString || searchString.length < 3) {
    return [];
  }

  const user = auth.currentUser;
  if (!user) throw new Error('User not authenticated.');

  const idToken = await user.getIdToken();

  const response = await fetch(`${API_BASE_URL}/fse/search`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${idToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ searchString, pageSize: 10 }),
  });

  const result = await response.json();

  if (!response.ok || result.status !== 'success') {
    throw new Error(result.message || 'Search failed');
  }

  return result.data?.franchisees || [];
};
